<template>
  <transition name="fade">
    <div
      v-if="overlayActive"
      class="side-menu-container fixed top-0 right-0 bottom-0 left-0 bg-black-full bg-opacity-25 z-sidebar-overlay"
      style="z-index:10000"
      @click.self="closeOverlay"
    >
      <transition :name="transitionName">
        <div
          v-if="showContent"
          :class="{
            right: isRightMenu,
            'fixed-footer': hasFixedFooter,
          }"
          class="side-menu"
          @click.self="closeOverlay"
        >
          <div class="bg-white w-full h-full">
            <div
              class="absolute top-0 right-0 left-0 bg-white h-64 border-b border-b-black-25 flex items-center justify-center font-medium"
            >
              <div
                v-if="activeSecondaryButton"
                class="absolute left-24 select-none cursor-pointer"
              >
                <img
                  src="~/assets/icons/arrow-left.png"
                  class="h-20 w-20"
                  @click="$emit('onSecondaryClick')"
                >
              </div>
              {{ heading }}
              <div
                class="absolute right-24 select-none cursor-pointer"
                @click="closeOverlay"
              >
                <img src="~/assets/icons/delete.png" class="h-20 w-20">
              </div>
            </div>
            <div class="h-full pt-64 overflow-auto">
              <slot />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export interface SideMenuInterface {
  openOverlay(): void;
  closeOverlay(): void;
}

export default defineComponent({
  props: {
    side: {
      type: String,
      required: false,
      default: 'right',
    },
    heading: {
      type: String,
      required: true,
    },
    activeSecondaryButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasFixedFooter: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['onSideMenuClose'],
  data() {
    return {
      overlayActive: false,
      showContent: false,
      windowWidth: 0,
    };
  },
  computed: {
    isMobile(): boolean {
      return this.windowWidth < 1024;
    },
    scrollBreakpoint(): number {
      return this.isMobile ? 98 : 128;
    },
    isRightMenu(): boolean {
      if (this.side === 'right') {
        return true;
      }
      return false;
    },
    transitionName(): string {
      if (this.side === 'right') {
        return 'slide-right';
      }
      return 'slide-left';
    },
  },
  mounted() {
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
  },
  beforeUnmount() {
    document.body.classList.remove('locked');
  },
  methods: {
    openOverlay() {
      this.overlayActive = true;
      document.body.classList.add('locked');
      setTimeout(() => (this.showContent = true), 50);
    },
    closeOverlay() {
      this.showContent = false;
      document.body.classList.remove('locked');
      setTimeout(() => {
        this.overlayActive = false;
        this.$emit('onSideMenuClose');
      }, 200);
    },
  },
});
</script>

<style scoped lang="postcss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-right-enter-active {
  transition: all 0.3s ease;
}
.slide-right-leave-active {
  transition: all 0.3s;
}
.slide-right-enter-from,
.slide-right-leave-to {
  transform: translateX(300px);
}

.slide-left-enter-active {
  transition: all 0.3s ease;
}
.slide-left-leave-active {
  transition: all 0.3s;
}
.slide-left-enter-from,
.slide-left-leave-to {
  transform: translateX(-300px);
}

.side-menu {
  @apply fixed rounded-tr-xl top-0 left-0 bottom-0 max-w-380 bg-white overflow-hidden;
  width: 90%;
}

.side-menu.fixed-footer {
  @apply rounded-br-xl;
}

.side-menu.right {
  @apply right-0 left-auto rounded-tr-none rounded-br-none rounded-tl-xl;
}

.side-menu.right.fixed-footer {
  @apply rounded-bl-xl;
}
</style>
